import { styled } from '@mui/material';
import { TableContainer, Box, Tabs } from '@mui/material';

// Styled components for dark tables
export const DarkTableContainer = styled(TableContainer)(({ theme }) => ({
  overflow: 'auto',
  maxWidth: '100%',
  '& .MuiTableCell-root': {
    color: theme.palette.common.white,
    borderColor: 'rgba(255, 255, 255, 0.15)',
    [theme.breakpoints.down('sm')]: {
      padding: '8px',
    },
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    backgroundColor: '#123',
    fontWeight: 'bold',
  },
  '& .MuiTableBody-root .MuiTableCell-root': {
    backgroundColor: '#123',
  },
  '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(odd) .MuiTableCell-root': {
    backgroundColor: '#123',
  },
  '& .position-column': {
    width: '70px',
    minWidth: '50px',
    [theme.breakpoints.down('sm')]: {
      width: '50px',
      minWidth: '40px',
    },
  },
  '& .standard-column': {
    width: 'auto',
    minWidth: '120px',
    [theme.breakpoints.down('sm')]: {
      minWidth: '100px',
    },
  },
}));

// Fixed height tab container
export const FixedTabContainer = styled(Box)(({ theme }) => ({
  borderBottom: '1px solid rgba(255,255,255,0.1)',
  height: 48,
  marginBottom: theme.spacing(4),
  position: 'relative',
  zIndex: 5,
  display: 'flex',
  width: '100%',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    height: 40,
  },
}));

// Custom tabs component
export const StableTabs = styled(Tabs)(({ theme }) => ({
  width: '100%',
  height: '100%',
  '& .MuiTabs-scroller': {
    width: '100%',
  },
  '& .MuiTabs-flexContainer': {
    height: '100%',
    width: '100%',
    display: 'flex',
  },
  '& .MuiTab-root': {
    flex: 1,
    maxWidth: 'none',
    minWidth: 0,
    minHeight: '100%',
    textTransform: 'none',
    padding: '6px 12px',
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: '1rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8rem',
      padding: '4px 8px',
    },
  },
}));

// Content wrapper
export const TabContentWrapper = styled(Box)(({ theme, noshadow }) => ({
  position: 'relative',
  zIndex: 1,
  '& > .MuiPaper-root': {
    boxShadow: noshadow === 'true' ? 'none' : undefined,
  },
}));
